"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePremiumCalculationDto = exports.PremiumCalculationDocumentDto = exports.RemarksSectionDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class RemarksSectionDto {
}
exports.RemarksSectionDto = RemarksSectionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Remarks for the calculation",
        example: "This is my remarks data",
    }),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string" }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], RemarksSectionDto.prototype, "remarks", void 0);
class PremiumCalculationDocumentDto {
}
exports.PremiumCalculationDocumentDto = PremiumCalculationDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], PremiumCalculationDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 35,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], PremiumCalculationDocumentDto.prototype, "documentId", void 0);
class CreatePremiumCalculationDto {
}
exports.CreatePremiumCalculationDto = CreatePremiumCalculationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Opportunity Activity ID",
        example: 750,
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity Activity ID must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity Activity ID is required" }),
    tslib_1.__metadata("design:type", Number)
], CreatePremiumCalculationDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Status Lookup ID",
        example: 403,
    }),
    (0, class_validator_1.IsInt)({ message: "Status Lookup ID must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Status Lookup ID is required" }),
    tslib_1.__metadata("design:type", Number)
], CreatePremiumCalculationDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Premium calculation details as key-value pairs",
        example: {
            "101": "This is my Commercial vessels data",
            "102": "This is my ships",
            "103": "This is my data",
        },
    }),
    (0, class_validator_1.IsObject)({ message: "premiumCalculationDetails must be an object" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], CreatePremiumCalculationDto.prototype, "premiumCalculationDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Remarks section object",
        type: RemarksSectionDto,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RemarksSectionDto),
    tslib_1.__metadata("design:type", RemarksSectionDto)
], CreatePremiumCalculationDto.prototype, "remarksSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Array of document objects",
        type: [PremiumCalculationDocumentDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PremiumCalculationDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreatePremiumCalculationDto.prototype, "documents", void 0);
